var els = $('[data-phone-fields-container]');
if (els.length > 0) {
  require.ensure('../modules/phone_numbers', function(require) {
    var PhoneNumbers = require('../modules/phone_numbers');
    return new PhoneNumbers();
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/phone_numbers.initializer.js